import styles from './NotFound.module.scss';

export const NotFound = () => {
    return (
        <div className={styles.block}>
            404
        </div>
    );
}